export const RoleNames = {
  company: [1, 3, 27],
  user: [2],
};
